import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7da80e28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "update-params-groups" }
const _hoisted_2 = {
  key: 0,
  class: "update-params-groups__params update-params-groups__form"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "update-params-groups__btns" }
const _hoisted_5 = { class: "update-params-groups__title" }
const _hoisted_6 = { class: "update-params-groups__form with-padding" }

import { computed, onMounted, ref, Ref } from 'vue';
import { ErrorsType, ParamGroupType, ParamsDataType } from '@/types';
import { ParamsValuesType } from '@/api/developer/types';
import { UpdateForm } from '@/components';
import { ValidationRuleWithoutParams } from '@vuelidate/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateParamsGroups',
  props: /*#__PURE__*/_mergeModels({
    paramsGroups: {},
    paramValues: {},
    parentId: {},
    errors: {},
    rules: {}
  }, {
    "paramsData": {},
    "paramsDataModifiers": {},
    "v$": {},
    "v$Modifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels([
  'validationErrorsHandlerByKey',
  'inputTouch',
  'focus',
  'changeCategory',
  'createCategory',
  'deleteCategory',
], ["update:paramsData", "update:v$"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
// eslint-disable-next-line no-undef
const paramsData = _useModel<ParamsDataType>(__props, 'paramsData');
// eslint-disable-next-line no-undef
const v$ = _useModel<ParamsDataType>(__props, 'v$');

const errorsGroupIds = computed((): number[] => {
  let errorIds: number[] = [];

  componentBtns.value.forEach(group => {
    const params = getActiveParams(group.id);

    params.forEach(param => {
      if (props.errors[param.id]) {
        errorIds.push(group.id);
      }
    });
  });

  return errorIds;
});

const componentBtns = computed(() => {
  return props.paramsGroups
    .filter(group => group.parent === 0)
    .map(el => {
      return {
        id: el.id,
        title: el.title,
      };
    });
});

const activeParamsGroupId: Ref<undefined | number> = ref(undefined);

const getActiveParams = (categoryId: number | string) => {
  return props.paramValues.filter(el => el.group_id === categoryId);
};
const getActiveGroups = (categoryId: number | string) => {
  return props.paramsGroups.filter(el => el.parent === categoryId);
};

const changeActiveParamsGroupId = (categoryId: number) => {
  activeParamsGroupId.value = categoryId;
};

onMounted(() => {
  changeActiveParamsGroupId(props.paramsGroups[0].id);
});

return (_ctx: any,_cache: any) => {
  const _component_base_expansion_panels = _resolveComponent("base-expansion-panels")!
  const _component_base_menu_with_tabs = _resolveComponent("base-menu-with-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_menu_with_tabs, {
      activeComponent: activeParamsGroupId.value,
      "btn-ids-with-errors": errorsGroupIds.value,
      componentBtns: componentBtns.value,
      bgColor: "#fff",
      "mobile-show-all-blocks": "",
      withRadius: "",
      onChangeActiveBtn: _cache[14] || (_cache[14] = ($event: any) => (changeActiveParamsGroupId($event)))
    }, {
      content: _withCtx((contentProps) => [
        (getActiveParams(contentProps.data))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(UpdateForm), {
                paramsData: paramsData.value,
                "onUpdate:paramsData": _cache[0] || (_cache[0] = ($event: any) => ((paramsData).value = $event)),
                v$: v$.value,
                "onUpdate:v$": _cache[1] || (_cache[1] = ($event: any) => ((v$).value = $event)),
                errors: _ctx.errors,
                params: getActiveParams(contentProps.data),
                "parent-id": _ctx.parentId,
                rules: _ctx.rules,
                onValidationErrorsHandlerByKey: _cache[2] || (_cache[2] = ($event: any) => (
              _ctx.$emit('validationErrorsHandlerByKey', $event)
            )),
                onInputTouch: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('inputTouch', $event))),
                "onFocus-": _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('focus', $event))),
                onChangeCategory: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('changeCategory', $event))),
                onCreateCategory: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('createCategory', [$event[0], $event[1]]))),
                onDeleteCategory: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('deleteCategory', [$event[0], $event[1]])))
              }, null, 8, ["paramsData", "v$", "errors", "params", "parent-id", "rules"])
            ]))
          : _createCommentVNode("", true),
        (
            getActiveGroups(contentProps.data) &&
            getActiveGroups(contentProps.data).length
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getActiveGroups(contentProps.data), (item) => {
                  return (_openBlock(), _createBlock(_component_base_expansion_panels, {
                    key: item.id,
                    styleType: "simple-green"
                  }, {
                    title: _withCtx((titleProps) => [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1)
                    ]),
                    content: _withCtx((contentProps) => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_unref(UpdateForm), {
                          paramsData: paramsData.value,
                          "onUpdate:paramsData": _cache[8] || (_cache[8] = ($event: any) => ((paramsData).value = $event)),
                          v$: v$.value,
                          "onUpdate:v$": _cache[9] || (_cache[9] = ($event: any) => ((v$).value = $event)),
                          errors: _ctx.errors,
                          params: _ctx.paramValues.filter(el => el.group_id === item.id),
                          "parent-id": _ctx.parentId,
                          rules: _ctx.rules,
                          onValidationErrorsHandlerByKey: _cache[10] || (_cache[10] = ($event: any) => (
                      _ctx.$emit('validationErrorsHandlerByKey', $event)
                    )),
                          onInputTouch: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('inputTouch', $event))),
                          "onFocus-": _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('focus', $event))),
                          onChangeCategory: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('changeCategory', $event)))
                        }, null, 8, ["paramsData", "v$", "errors", "params", "parent-id", "rules"])
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["activeComponent", "btn-ids-with-errors", "componentBtns"])
  ]))
}
}

})